import Email from "../assets/svgs/email";
import Facebook from "../assets/svgs/facebook";
import Instagram from "../assets/svgs/instagram";
import LocationSvg from "../assets/svgs/location";
import TelephoneFull from "../assets/svgs/telephone-full";

export const ContactUs = () => {

    const text = `שעות פתיחה: ימים א׳-ה׳: 08:00-20:00
     יום ו׳: 08:00-12:20`;
    return (
        <section className="contact-us">
            <h1>צרו איתנו קשר</h1>

            <div className="contact-text-container">
                <div>
                    {text.split('\n').map((line, index) => (
                        <p key={index}>{line}</p>
                    ))}
                </div>
                <b>נא לבצע הזמנה לפחות יום מראש</b>

                <section className="location-tel flex column">
                    <a className="telephone-container flex justify-center align-center " target="_blanc" href="tel:972528011016">
                        <TelephoneFull />
                        <span >052-8011016</span>
                    </a>
                    <div className="location-container flex justify-center align-center ">
                        <LocationSvg />
                        <span>גדעון האוזנר 48, הולילנד ירושלים</span>
                    </div>
                </section>
            </div>

            <section className="social flex">
                <a target="_blanc" href="https://www.instagram.com/talikitchen?igsh=NHptZjVyaHAyaTg2&utm_source=qr"><Instagram /></a>
                <a target="_blanc" href="https://www.facebook.com/talidudu?mibextid=kFxxJD"><Facebook /></a>
                <a target="_blanc" href="mailto:Talido74@gmail.com"><Email /></a>
            </section>

        </section>
    );
};